import renderer from 'react-test-renderer';
import { renderToString } from 'fela-tools';
import felaTestContext from './felaTestContext';
import createRenderer from './createRenderer';
import cssbeautify from 'cssbeautify';

var options = {
  indent: '  ',
  openbrace: 'end-of-line',
  autosemicolon: false
};

export default (function (component) {
  var felaRenderer = createRenderer({
    dev: true
  });

  return {
    component: renderer.create(felaTestContext(component, felaRenderer)).toJSON(),
    styles: '\n' + cssbeautify(renderToString(felaRenderer), options) + '\n'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-provider/es/felaSnapshot.js
// module id = 1003
// module chunks = 1